<div class="skeleton-container" (click)="cta()">
  <div class="photo"></div>
  <div class="info">
    <span class="title"></span>
    <span class="author"></span>
    <div class="cta">
      <opac-icon icon="add_circle" size="2x"></opac-icon>
      <span>{{ 'checkouts.addNewContent' | translate }}</span>
    </div>
    <div class="button"></div>
  </div>
</div>
